module.exports = function( a ) {
  return a > 0.00001;
};
